// Opens the printable guest-token sheet for the given reservations. The ids travel through
// localStorage rather than the URL, so a large guest order never hits URL length limits.
const PREFIX = 'guestTokens.batch.';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

const purgeOldBatches = () => {
    try {
        const now = Date.now();
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (!key || !key.startsWith(PREFIX)) continue;
            const { createdAt } = JSON.parse(localStorage.getItem(key) || '{}');
            if (!createdAt || now - createdAt > MAX_AGE_MS) localStorage.removeItem(key);
        }
    } catch {
        // storage unavailable or corrupt entry: nothing to clean
    }
};

export const openGuestTokenPrint = (reservationIds: string[]) => {
    if (reservationIds.length === 0) return;
    purgeOldBatches();
    const batch = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
    const url = `/print/guest-tokens?batch=${batch}`;
    try {
        localStorage.setItem(PREFIX + batch, JSON.stringify({ ids: reservationIds, createdAt: Date.now() }));
    } catch {
        return;
    }
    const win = window.open(url, '_blank');
    if (!win) window.location.assign(url); // popup blocked: open the sheet in this tab instead
};

export const readGuestTokenBatch = (batch: string | null): string[] => {
    if (!batch) return [];
    try {
        const { ids } = JSON.parse(localStorage.getItem(PREFIX + batch) || '{}');
        return Array.isArray(ids) ? ids : [];
    } catch {
        return [];
    }
};
